/* src/app/shared/components/title/title.component.scss */
:host {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}
.title {
  font-size: large;
  line-height: 30px;
}
.label {
  font-size: medium;
  line-height: 30px;
}
/*# sourceMappingURL=title.component.css.map */
